<!-- ベースからのインセンティブ画面中継ページ -->
<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { AppConstants } from "@/constants/AppConstants";
import { useRoute, useRouter } from "vue-router";
import { outputDebugLogs } from "@/Common";
export default defineComponent({
  name: "BaseIncentiveRedirectComponent",
  setup() {
    const route = useRoute();
    const router = useRouter();

    // 初期処理
    onMounted(async () => {
      outputDebugLogs("BaseIncentiveRedirectComponent Start");
      // URLクエリから各パラメータを取得
      const systemkbn = route.query.systemkbn;
      const agcode = route.query.agcode;
      const daihyoCode = route.query.daihyoCode;
      const token = route.query.token;
      const userid = route.query.userid;
      outputDebugLogs("systemKbn: " + systemkbn);
      outputDebugLogs("agcode: " + agcode);
      outputDebugLogs("daihyoCode: " + daihyoCode);
      outputDebugLogs("token: " + token);
      outputDebugLogs("userid: " + userid);

      // 各パラメータが存在する場合にローカルストレージへ保存
      if (systemkbn) {
        localStorage.setItem(
          AppConstants.INCENTIVE_SYSTEM_KBN_SESSION_NAME,
          systemkbn.toString()
        );
      }
      if (agcode) {
        localStorage.setItem(
          AppConstants.INCENTIVE_AG_CODE_SESSION_NAME,
          agcode.toString()
        );
      }
      if (daihyoCode) {
        localStorage.setItem(
          AppConstants.INCENTIVE_DAIHYO_CODE_SESSION_NAME,
          daihyoCode.toString()
        );
      }
      if (token) {
        localStorage.setItem(
          AppConstants.INCENTIVE_TOKEN_SESSION_NAME,
          token.toString()
        );
      }
      if (userid) {
        localStorage.setItem(
          AppConstants.INCENTIVE_USER_ID_SESSION_NAME,
          userid.toString()
        );
      }

      outputDebugLogs("BaseIncentiveRedirectComponent End");
      // 保存後、遷移先の TargetPage へリダイレクト
      // replace() を利用することで、ブラウザの戻るボタンで中継ページに戻らないようにする
      router.replace({ name: "Incentive" });
    });
  },
});
</script>
